module.exports = __webpack_public_path__ + "img/23e223d.png";